import React, { useEffect, useState } from "react";
import { TextField, Button, Box, Paper, Typography } from "@mui/material";
import { Email, Send } from "@mui/icons-material";

const EmailForm = ({
  jobNo,
  reportNo,
  labRequestId,
  loggedUserData,
  emailAddress,
}) => {
  console.log("email ", emailAddress);
  const [email, setEmail] = useState(emailAddress);
  const [subject, setSubject] = useState(
    `Material Testing Laboratory - Kekirawa ${jobNo}`
  );
  const [body, setBody] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(gmailUrl, "_blank");
  };

  useEffect(() => {
    if (reportNo.startsWith("QC")) {
      setBody(
        `The Concrete Cube Test report for job no - ${jobNo} has been completed.

Download the report using the link below:
( පහත ලින්ක් එක මගින් වාර්තාව බාගත කරගන්න. )

🔗 Download Report
https://matlab.lk?labRequestId=${labRequestId}&reportNo=${reportNo}

We sincerely appreciate your continued trust and business.
${loggedUserData}
Material Testing Laboratory Team - Kekirawa
`
      );
    } else {
      setBody(
        `The Invoice for job no - ${jobNo}.

Download the invoice using the link below:
( පහත ලින්ක් එක මගින් කුවිතාන්සිය බාගත කරගන්න. )

🔗 Download Invoice
https://matlab.lk?labRequestId=${labRequestId}&reportNo=${reportNo}

We sincerely appreciate your continued trust and business.
${loggedUserData}
Material Testing Laboratory Team - Kekirawa
`
      );
    }
  }, []);

  return (
    <Paper elevation={3} sx={{ p: 4, width: 600, mx: "auto", mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        Send Email
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <TextField
          label="To"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          size="small"
        />

        <TextField
          label="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          size="small"
        />

        <TextField
          label="Message"
          multiline
          rows={20}
          value={body}
          onChange={(e) => setBody(e.target.value)}
          size="small"
        />

        <Button
          type="submit"
          variant="contained"
          startIcon={<Email />}
          color="success"
          sx={{ mt: 2 }}
        >
          Open Email
        </Button>
      </Box>
    </Paper>
  );
};

export default EmailForm;
